import React from 'react';

const ImpactSection = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl sm:text-5xl font-bold text-gray-900 mb-6">
              Herausforderung und Vorgehensweise
            </h2>
            <div className="prose prose-lg text-gray-700">
              <p className="mb-4">
                Die Fragen, die sich im Zusammenhang mit dem Klimawandel stellen, sind globaler Natur, weshalb daraus supranationale Ziele und Regeln abgeleitet werden. Die Antworten darauf werden jedoch von jedem Akteur im regionalen Kontext, in dem er tätig ist, gegeben. Die Herausforderung ist sowohl für Grossunternehmen als auch für KMUs enorm.
              </p>
              <p className="mb-4">
                Es gilt, die neue Ausgangslage zu verstehen, um Antworten für die Ausarbeitung einer eigenen, konkreten Strategie zu geben.
                Das Ziel besteht darin, sich an das neue Gesetz anzupassen und gleichzeitig in der daraus resultierenden nachhaltigen Wirtschaft konkurrenzfähig zu bleiben.
              </p>
              <p className="mb-4">
                Das 2020 vom Europäischen Parlament verabschiedete Klimaschutzgesetz wird von Land zu Land mit einigen Unterschieden in der Umsetzung angewendet. Heute ist es in allen Ländern in Kraft getreten. Es verpflichtet in seinen Grundzügen alle Unternehmen und KMUs in allen Ländern, unabhängig davon, ob sie EU-Mitglieder sind oder nicht.
              </p>
              <p className="mb-4">
                Haben Sie bereits eine Schätzung des CO₂-Fussabdrucks Ihres Unternehmens vorgenommen? Oder sogar die ersten möglichen Ansätze zur Reduzierung Ihres CO₂-Fussabdrucks definiert? Handelt es sich für Sie um Energieeffizienz, Transport, Produktion, Verpackung, Lagerung, Entsorgung…?
              </p>
              <p className="mb-4">
                Wir entwickeln Lösungen für den Klimaschutz, die von Aufforstungsprojekten bis hin zu massgeschneiderten Nachhaltigkeitsstrategien reichen. Das Ziel besteht darin, die grüne Wirtschaft schrittweise zu integrieren, ohne dabei Zeit zu verlieren.
                Wir bieten Ihnen an, zunächst mit einem ersten CO₂-Ausgleichskontingent zu beginnen und anschliessend eine Analyse durchzuführen, eine Strategie zu entwickeln und einen Fahrplan aufzustellen.
              </p>
            </div>
          </div>
          <div>
            <img
              src="https://images.unsplash.com/photo-1473448912268-2022ce9509d8?q=80&w=2000"
              alt="Wald"
              className="rounded-lg shadow-xl w-full h-auto"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImpactSection;